import React from "react";
import { Stack, Alert } from "investira.react.components";
import PropTypes from "prop-types";

const DetalhesErrorMessage = ({ show = false, ativosSize = 0 }) => {
  const errorMsg = (pSize) => {
    const isBigger = pSize > 1;
    return `${isBigger ? "Existem" : "Existe"} ${pSize} ${
      isBigger ? "ativos ignorados" : "ativo ignorado"
    } no cálculo por ausência de informação.`;
  };

  return (
    <>
      {show && (
        <Stack mb={2}>
          <Alert severity="warning" variant="filled">
            {errorMsg(ativosSize)}
          </Alert>
        </Stack>
      )}
    </>
  );
};

DetalhesErrorMessage.propTypes = {
  show: PropTypes.bool,
  ativosSize: PropTypes.number,
};

export default DetalhesErrorMessage;
